<template>
  <township-container toRoute="activity"></township-container>
</template>

<script>
import TownshipContainer from "@/components/township/TownshipContainerActivity.vue";
export default {
  components: {
    "township-container": TownshipContainer,
  },
};
</script>
